import { Component, Input, HostListener, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { SearchThemeEnum } from '../../enums/search-theme.enum';



@Component({
    selector: 'tk-search',
    styleUrls: ['./search.component.less'],
    templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {

    /**
     * Filter form
     */
    @Input() public control!: AbstractControl;

    /**
     * Flag indicating whether filter request is being processed
     */
    @Input() public loading = false;

    /**
     * Flag indicating whether datk theme is applied
     */
    @Input() public themeType = SearchThemeEnum.Normal;

    /**
     *
     */
    @Output() public onEnterEvent: EventEmitter<null> = new EventEmitter<null>();


    @Output() public onFocusEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
     *
     */
    @Output() public onClearEvent: EventEmitter<null> = new EventEmitter<null>();

    @ViewChild('searchInput') inputField?: ElementRef;

    public hasFocus = false;

    public searchThemeEnum = SearchThemeEnum;

    constructor() {

    }

    ngOnInit() {
    }

    /**
     * Handles enter's presses
     * @param event keyboard event
     */
    @HostListener('keydown.enter', ['$event'])
    public onEnter(event: KeyboardEvent): void {

        this.onEnterEvent.emit(null);
    }

    public setFocus(): void {
        setTimeout(() => this.inputField?.nativeElement.focus(), 50);
    }

    /**
     * Clears form's phrase
     */
    public onClear(): void {

        // Clear phrase and send filter request
        this.control?.setValue('');
        this.onClearEvent.emit(null);
        this.inputField?.nativeElement.focus();
    }

    public onFocus() {
        this.hasFocus = true;
        this.onFocusEvent.emit(this.hasFocus);
    }

    public onBlur() {
        this.hasFocus = false;
        this.onFocusEvent.emit(this.hasFocus);
    }

}

